export default __webpack_public_path__ + "static/young-toddler10-8cb50e209ee1eff79e373ffbe9bf2bcb.jpg";